import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { addPaymentTransactionThruLinkSchema } from "../schema/addPaymentTransactionThruLinkSchema";
import { InputAdornment } from "@mui/material";
import { IconButton } from "@mui/material";
import { serializeToString } from "xmlserializer";
import QRCode from "react-qr-code";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { generatePaymentLinkWithCustomAmount } from "../../../api/caseApi";
import Spinner from "../../../common/components/Spinner";
const AddPaymentTransactionThruLinkDialog = ({
  openAddPaymentTransaction,
  handleCloseAddPaymentTransaction,
  getPaymentTransactions,
  caseDetails,
}) => {
  const [types, setTypes] = useState([]);
  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(addPaymentTransactionThruLinkSchema),
  });
  const [loading, setLoading] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [modeOfPayment, setModeOfPayment] = useState(null);
  const [currentCaseProgress, setCurrentCaseProgress] = useState(null);

  const amount = watch("amount");
  const caseProgressId = watch("caseProgressId");

  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseId = caseDetails.id;
    reset({ ...defaultValues });
    let designCount = 0,
      setCount = 0;
    setTypes([]);
    caseDetails.caseProgressions.forEach((cp) => {
      if (cp.type === "F2F Consultation") {
        let type = { name: "F2F Consultation Payment", caseProgressId: cp.id };
        setTypes((prev) => [...prev, type]);
      } else if (cp.type === "Scanning") {
        let type = { name: "Scanning Payment", caseProgressId: cp.id };
        setTypes((prev) => [...prev, type]);
      } else if (cp.type === "Design") {
        if (designCount === 0) {
          let type = { name: "Design Payment", caseProgressId: cp.id };
          setTypes((prev) => [...prev, type]);
          designCount++;
        }
      }
      // else if (cp.type === "Set" && cp.isPaid === false) {
      //   if (setCount === 0) {
      //     let type = { name: "Set Payment", caseProgressId: cp.id };
      //     setTypes((prev) => [...prev, type]);
      //     setCount++;
      //   }
      // }
    });
  }, [caseDetails]);

  const handleSetCaseProgress = (id) => {
    caseDetails.caseProgressions.forEach((cp) => {
      if (cp.id === id) {
        setCurrentCaseProgress(cp);
      }
    });
  };

  const submitPaymentEmailWithCustomAmount = async (values) => {
    setLoading(true);
    try {
      const response = await generatePaymentLinkWithCustomAmount(
        modeOfPayment,
        values.caseProgressId,
        values.amount,
      );
      setPaymentLink(response.data.link);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  const onImageCownload = () => {
    const svg = document.getElementById("QRCode");
    const svgData = serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = "AlinaPayQR";
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  return (
    <div>
      <StyledDialog
        open={openAddPaymentTransaction}
        onClose={() => {
          handleCloseAddPaymentTransaction();
          reset();
        }}
        fullWidth
        maxWidth="md"
        width="900px"
      >
        <DialogTitle>Generate Payment Link with Custom Amount</DialogTitle>
        <form onSubmit={handleSubmit(submitPaymentEmailWithCustomAmount)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={6.5}>
                <Controller
                  control={control}
                  name="caseProgressId"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      options={types}
                      onChange={(_, val) => {
                        onChange(val?.caseProgressId || "");
                        handleSetCaseProgress(val?.caseProgressId);
                      }}
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(error)}
                          label={"Payment Type"}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.caseProgressId}>
                            {option.name}
                          </li>
                        );
                      }}
                      sx={{ width: "100%", paddingBottom: "20px" }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6.5}>
                <StyledTextField
                  sx={{ width: "100%" }}
                  variant="outlined"
                  label="Amount"
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.amount}
                  helperText={errors.amount?.message}
                  {...register("amount")}
                />
              </Grid>
            </Grid>

            <Grid container direction={"column"} gap={1}>
              {/* {caseProgressId && amount && (
                <Grid item xs={12}>
                  <StyledButton
                    type="submit"
                    theme="green"
                    onClick={() => setModeOfPayment("PayPal")}
                  >
                    Generate Paypal Payment Link
                  </StyledButton>
                </Grid>
              )}
              {caseProgressId && amount && (
                <Grid item xs={12}>
                  <StyledButton
                    type="submit"
                    theme="green"
                    onClick={() => setModeOfPayment("GCash")}
                  >
                    Generate GCash Payment Link
                  </StyledButton>
                </Grid>
              )} */}
              {caseProgressId && amount && (
                <Grid item xs={12}>
                  <StyledButton
                    type="submit"
                    theme="green"
                    onClick={() => setModeOfPayment("Xendit")}
                  >
                    Generate Xendit Payment Link
                  </StyledButton>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                style={{ display: !loading ? "none" : "inherit" }}
              >
                <Spinner color={"black"} />
              </Grid>
            </Grid>

            <Grid container rowSpacing={2}>
              {paymentLink !== "" && (
                <Grid
                  rowSpacing={2}
                  container
                  style={{
                    border: "1px solid #d6d6d6",
                    padding: "10px",
                    borderRadius: "5px",
                    marginBottom: "20px",
                    marginTop: "50px",
                  }}
                >
                  <Grid item xs={5}>
                    <QRCode
                      id="QRCode"
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "60%",
                        width: "60%",
                      }}
                      value={paymentLink}
                      viewBox={`0 0 256 256`}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <StyledButton onClick={onImageCownload} theme="green">
                      Download QR Code
                    </StyledButton>
                  </Grid>

                  <Grid item xs={12}>
                    Or
                  </Grid>
                  <Grid item xs={12}>
                    <StyledTextField
                      inputProps={{ readOnly: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                navigator.clipboard.writeText(paymentLink)
                              }
                              sx={{ width: "36px", height: "32px" }}
                            >
                              <FontAwesomeIcon
                                fontSize="medium"
                                icon={faCopy}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      value={paymentLink}
                      label={"Link"}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </DialogContent>

          <DialogActions>
            <Grid item xs={12}>
              <StyledButton
                theme="purple"
                type="button"
                onClick={handleCloseAddPaymentTransaction}
              >
                Cancel
              </StyledButton>
            </Grid>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddPaymentTransactionThruLinkDialog;
